import React, {ReactElement} from "react";
import { DeactivateCustomerMutationMutation, DeactivateCustomerMutationMutationVariables } from "../../../schemaTypes";
import { normalizeErrors } from "../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../types/NormalizedErrorMap";
import { gql, useMutation } from "@apollo/client";


const deactivateCustomerMutation = gql`
  mutation DeactivateCustomerMutation($input: DeactivateCustomerInput!) {
    deactivateCustomer(input: $input) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submit: (
        values: DeactivateCustomerMutationMutationVariables
      ) => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      error: any;
      message: string | null;
    }
  ) => ReactElement | null;
}

export const DeactivateCustomerController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    DeactivateCustomerMutationMutation,
    DeactivateCustomerMutationMutationVariables
  >(deactivateCustomerMutation);

  const submit = async (values: DeactivateCustomerMutationMutationVariables) => {
    const { data: {deactivateCustomer} }:any = await mutate({ variables: values });

    if (deactivateCustomer?.errors) {
      return normalizeErrors(deactivateCustomer.errors);
    }

    return null;
  };

  const message = data?.deactivateCustomer?.message || null;

  return children({
    submit,
    loading,
    error,
    message,
  });
};

